

import { Component, Prop, Vue } from 'vue-property-decorator';
import { DevicesModule } from '~/store/modules/devices';
import { RoomsModule } from '~/store/modules/rooms';
import { RoomData } from '~/interfaces/rooms.interface';
import Room from '~/components/Room.vue';

@Component({
    components: {
        Room,
    },
})
export default class RoomsLayout extends Vue {

    @Prop() expand!: boolean;

    get currentModuleId() {
        return DevicesModule.currentModuleId;
    }

    get currentRooms() {
        return RoomsModule.currentRooms.sort((roomA: RoomData, roomB: RoomData) => {
            return roomB.is_empty ? -1 : 1;
        });
    }

    get currentGatewayRoomlessModuleIds() {
        return DevicesModule.currentGatewayRoomlessModuleIds;
    }

    get panels() {
        const val: number[][] = [];
        this.currentRooms.forEach(() => {
            if (this.expand) {
                val.push([0]);
            } else {
                val.push([]);
            }
        });
        return val;
    }

    roomModules(roomId: string) {
        return RoomsModule.roomModules(roomId);
    }

    isCurrentModuleInRoom(roomId: string) {
        if (!this.currentModuleId) {
            return false;
        }
        if (roomId === 'notinaroom') {
            return DevicesModule.currentModule && !DevicesModule.currentModule.room_id;
        } else {
            const roomModules = RoomsModule.roomModules(roomId);
            return roomModules?.find((moduleId) => moduleId === this.currentModuleId);
        }
    }
}
